/**
 * Suppress the "Lit is in dev mode" console warning in development.
 *
 * Lit tracks issued warnings in `globalThis.litIssuedWarnings` and skips a
 * warning when its code is already present. Seeding the `dev-mode` code
 * before Lit loads hides only this banner; all other Lit warnings keep
 * working. Production builds use the Lit production build and never log it.
 */
window.litIssuedWarnings = window.litIssuedWarnings || new Set();
window.litIssuedWarnings.add('dev-mode');
